/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindCertificateByIdQueryResponse,
  FindCertificateByIdPathParams,
} from "../types/FindCertificateById.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCertificateByIdQueryKey = (
  id: FindCertificateByIdPathParams["id"] | undefined
) =>
  [
    { url: "/v1/certificate/find-certificate-by-id/:id", params: { id: id } },
  ] as const

export type FindCertificateByIdQueryKey = ReturnType<
  typeof findCertificateByIdQueryKey
>

/**
 * {@link /v1/certificate/find-certificate-by-id/:id}
 */
export async function findCertificateById(
  id: FindCertificateByIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificateByIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate/find-certificate-by-id/${id}`,
    ...requestConfig,
  })
  return res
}

export function findCertificateByIdQueryOptions(
  id: FindCertificateByIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCertificateByIdQueryKey(id)
  return queryOptions<
    ResponseConfig<FindCertificateByIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificateByIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return findCertificateById(id!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * {@link /v1/certificate/find-certificate-by-id/:id}
 */
export function useFindCertificateById<
  TData = ResponseConfig<FindCertificateByIdQueryResponse>,
  TQueryData = ResponseConfig<FindCertificateByIdQueryResponse>,
  TQueryKey extends QueryKey = FindCertificateByIdQueryKey,
>(
  id: FindCertificateByIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificateByIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findCertificateByIdQueryKey(id)

  const query = useQuery(
    {
      ...findCertificateByIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
